var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { Fragment } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { getLoginBaseURL } from '@finect/front-utils/getLoginBaseURL';
import { keyMap } from '@finect/front-utils/keyMap';
import { debounce } from '@finect/front-utils/debounce';
import { cancelablePromise } from '@finect/front-utils/cancelablePromise';
import { getProductTypeById, productTypes } from '@finect/front-resources/Products';
import { grid } from '@finect/tabular-utils/grid';
import { clearAllBodyScrollLocks, disableBodyScroll } from '@finect/tabular-utils/bodyScrollLock';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { Search } from '@finect/tabular-icons/search';
import { X } from '@finect/tabular-icons/x';
import { Tag } from '@finect/tabular-components/Tags';
import { dataLayer } from '@finect/front-gtm';
import { search, getSubscriptions, subscribe, unsubscribe, getViewedProducts, mapType } from '../actions';
import { SearchResultItem } from './SearchResultItem';
import { SearchShortcuts } from './SearchShortcuts';
const show = keyframes(["from{opacity:0;}to{opacity:1;}"]);
const SearchBar = styled.div.withConfig({
  displayName: "OmniSearch__SearchBar",
  componentId: "sc-1iquiix-0"
})(["flex:1;max-width:100px;height:60px;padding:12px 0 0;margin-left:auto;", ";", ";"], maxMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-left: 15px;\n    padding-right: 0;\n  "]))), maxMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding-left: 9px;\n    padding-right: 0;\n  "]))));
const activeStyles = css(["position:fixed;z-index:9000;top:0;left:0;right:0;padding:3px 30px 0;background-color:#fff;color:", ";animation:", " 0.3s cubic-bezier(0.49,0.42,0.52,0.98);", ";", ";"], _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.font;
}, show, maxMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding-left: 24px;\n    padding-right: 24px;\n  "]))), maxMediaQueries.phone(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    padding-left: 15px;\n    padding-right: 15px;\n  "]))));
const inactiveStyles = css(["", ";"], maxMediaQueries.phablet(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    float: right;\n    width: 36px;\n  "]))));
const SearchBarContent = styled.div.withConfig({
  displayName: "OmniSearch__SearchBarContent",
  componentId: "sc-1iquiix-1"
})(["width:100%;color:#fff;", ";"], _ref2 => {
  let {
    isActive
  } = _ref2;
  return isActive ? activeStyles : inactiveStyles;
});
const SearchBarInner = styled.div.withConfig({
  displayName: "OmniSearch__SearchBarInner",
  componentId: "sc-1iquiix-2"
})(["position:relative;", ";margin:0 auto;&:hover{", ";}"], _ref3 => {
  let {
    isActive
  } = _ref3;
  return isActive && "max-width: ".concat(grid(8), "px;");
}, _ref4 => {
  let {
    theme,
    isActive
  } = _ref4;
  return !isActive ? "color:".concat(theme.colors.primaryLL) : '';
});
const SearchIcon = styled.div.withConfig({
  displayName: "OmniSearch__SearchIcon",
  componentId: "sc-1iquiix-3"
})(["", ";position:absolute;top:9px;left:9px;pointer-events:none;", ";"], _ref5 => {
  let {
    isActive
  } = _ref5;
  return isActive && 'display: none;';
}, maxMediaQueries.phablet(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    left: 9px;\n  "]))));
const SearchType = styled.div.withConfig({
  displayName: "OmniSearch__SearchType",
  componentId: "sc-1iquiix-4"
})(["", ";position:absolute;top:15px;right:30px;pointer-events:none;", ";"], _ref6 => {
  let {
    isActive
  } = _ref6;
  return isActive && 'display: none;';
}, maxMediaQueries.phablet(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    left: 9px;\n  "]))));
const inputActiveStyles = css(["height:57px;padding-right:42px;border-bottom:1px solid ", ";", ";color:", ";::placeholder{color:", ";}", ";"], _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.borderColor;
}, getFont(2), _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.colors.font;
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.colors.fontLL;
}, maxMediaQueries.phablet(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    ", ";\n  "])), getFont(1)));
const inputInactiveStyles = css(["height:36px;padding:0 12px 0 24px;border-radius:", ";cursor:pointer;", ";", " ", ";::placeholder{color:rgb(255 255 255 / 0.75);}&:input-placeholder{padding-left:36px !important;}"], _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.borderRadius;
}, getFont(0), fontSmoothing, maxMediaQueries.phablet(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    padding: 0 0 0 36px;\n  "]))));
const SearchInput = styled.input.withConfig({
  displayName: "OmniSearch__SearchInput",
  componentId: "sc-1iquiix-5"
})(["width:100%;background-color:transparent;font-family:", ";color:#fff;", ";::placeholder{padding-left:2px;}&:focus{::placeholder{color:", ";}}"], _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.bodyFontFamily;
}, _ref12 => {
  let {
    isActive
  } = _ref12;
  return isActive ? inputActiveStyles : inputInactiveStyles;
}, _ref13 => {
  let {
    theme
  } = _ref13;
  return theme.colors.fontLL;
});
const SearchText = styled.span.withConfig({
  displayName: "OmniSearch__SearchText",
  componentId: "sc-1iquiix-6"
})(["position:absolute;left:0;", ";visibility:hidden;pointer-events:none;white-space:nowrap;", ";"], getFont(2), maxMediaQueries.phablet(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    ", ";\n  "])), getFont(1)));
const progressActiveStyles = css(["position:absolute;top:55px;width:", "px;max-width:100%;height:2px;background-color:", ";"], _ref14 => {
  let {
    textWidth
  } = _ref14;
  return textWidth;
}, _ref15 => {
  let {
    theme
  } = _ref15;
  return theme.secondaryColor;
});
const TextProgress = styled.div.withConfig({
  displayName: "OmniSearch__TextProgress",
  componentId: "sc-1iquiix-7"
})(["", ";"], _ref16 => {
  let {
    isActive
  } = _ref16;
  return isActive && progressActiveStyles;
});
const CloseSearch = styled.div.withConfig({
  displayName: "OmniSearch__CloseSearch",
  componentId: "sc-1iquiix-8"
})(["position:absolute;top:9px;right:0;width:36px;height:36px;padding:8px;cursor:pointer;text-align:center;&:before{position:absolute;z-index:0;top:0;bottom:0;left:0;right:0;opacity:0;border-radius:36px;content:'';background:", ";transform:scale(0);transition-duration:0.15s;transition-property:transform,opacity;transition-timing-function:cubic-bezier(0.4,0,0.2,1);}svg{position:relative;z-index:1;}&:hover{color:", ";&:before{opacity:1;transform:scale(1);}}"], _ref17 => {
  let {
    theme
  } = _ref17;
  return theme.colors.uiL;
}, _ref18 => {
  let {
    theme
  } = _ref18;
  return theme.buttonColor;
});
const SearchResults = styled.div.withConfig({
  displayName: "OmniSearch__SearchResults",
  componentId: "sc-1iquiix-9"
})(["padding:0 30px 36px;", ";", ";"], maxMediaQueries.phablet(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    padding-left: 24px;\n    padding-right: 24px;\n  "]))), maxMediaQueries.phone(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    padding-left: 0;\n    padding-right: 0;\n  "]))));
const SearchResultsInner = styled.div.withConfig({
  displayName: "OmniSearch__SearchResultsInner",
  componentId: "sc-1iquiix-10"
})(["max-width:", "px;margin:0 auto;"], grid(8));
const OmniSearchBlock = styled.div.withConfig({
  displayName: "OmniSearch__OmniSearchBlock",
  componentId: "sc-1iquiix-11"
})(["position:fixed;z-index:1000;top:0;bottom:0;left:0;right:0;overflow-x:hidden;overflow-y:auto;-webkit-overflow-scrolling:touch;padding-top:78px;background-color:#fff;animation:", " 0.3s cubic-bezier(0.49,0.42,0.52,0.98);", ";"], show, _ref19 => {
  let {
    loading
  } = _ref19;
  return loading && 'filter: blur(3px);';
});
const trackSearchTerm = searchTerm => {
  dataLayer({
    id: 'Search',
    type: 'search',
    params: {
      searchTerm
    }
  });
};
export class OmniSearch extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "input", void 0);
    _defineProperty(this, "spanText", void 0);
    _defineProperty(this, "target", void 0);
    _defineProperty(this, "pendingPromises", []);
    _defineProperty(this, "searchTimeout", null);
    _defineProperty(this, "state", {
      subscriptions: {},
      views: [],
      isActive: false,
      textWidth: 0,
      results: [],
      searching: false,
      showResults: false,
      selected: -1,
      type: null
    });
    _defineProperty(this, "appendPendingPromise", promise => this.pendingPromises = [...this.pendingPromises, promise]);
    _defineProperty(this, "removePendingPromise", promise => this.pendingPromises = this.pendingPromises.filter(pendingPromise => pendingPromise !== promise));
    _defineProperty(this, "selectTag", type => {
      if (type === this.state.type) return this.setState({
        type: null
      });
      this.setState({
        type
      });
    });
    _defineProperty(this, "hideResults", () => {
      this.setState({
        showResults: false,
        searching: false
      });
    });
    _defineProperty(this, "processPromise", wrappedPromise => {
      this.setState({
        searching: true
      });
      wrappedPromise.promise.then(results => {
        if (results) {
          this.setState({
            results,
            searching: false,
            showResults: true,
            selected: 0,
            type: null
          });
        } else {
          this.setState({
            searching: false,
            results: [],
            showResults: true,
            selected: -1,
            type: null
          });
        }
      }).then(() => {
        this.removePendingPromise(wrappedPromise);
      }).catch(errorInfo => {
        if (!errorInfo.isCanceled) {
          this.removePendingPromise(wrappedPromise);
        }
      });
    });
    _defineProperty(this, "debouncedSearch", debounce(search));
    _defineProperty(this, "getResults", searchTerm => {
      const wrappedPromise = cancelablePromise(this.debouncedSearch(searchTerm));
      this.appendPendingPromise(wrappedPromise);
      this.processPromise(wrappedPromise);
    });
    _defineProperty(this, "isFollowing", (type, id) => {
      const {
        subscriptions
      } = this.state;
      const entity = mapType(type);
      if (subscriptions && !subscriptions.hasOwnProperty(entity)) return false;
      return subscriptions[entity].includes(id.toUpperCase());
    });
    _defineProperty(this, "handleSubscribe", async (type, id) => {
      const entity = mapType(type);
      if (this.props.isLoggedIn && entity) {
        const result = await subscribe(entity, id);
        if ([200, 201].includes(result === null || result === void 0 ? void 0 : result.code)) {
          this.setState(state => {
            const newSubscriptions = _objectSpread({}, state.subscriptions);
            if (!newSubscriptions.hasOwnProperty(entity)) {
              newSubscriptions[entity] = [];
            }
            newSubscriptions[entity].push(id);
            return {
              subscriptions: newSubscriptions
            };
          });
        }
      } else {
        const blob = {
          copy: 'Para realizar esta acción accede a tu cuenta de Finect',
          action: 'subscribe',
          target: {
            type: entity,
            id
          }
        };
        location.href = "".concat(getLoginBaseURL(), "/login?action=").concat(Buffer.from(JSON.stringify(blob)).toString('base64'));
      }
    });
    _defineProperty(this, "handleUnSubscribe", async (type, id) => {
      const entity = mapType(type);
      if (this.props.isLoggedIn && entity) {
        const result = await unsubscribe(entity, id);
        if ([200, 204].includes(result === null || result === void 0 ? void 0 : result.code)) {
          this.setState(state => {
            const newSubscriptions = _objectSpread({}, state.subscriptions);
            newSubscriptions[entity].splice(newSubscriptions[entity].indexOf(id), 1);
            return {
              subscriptions: newSubscriptions
            };
          });
        }
      }
    });
    _defineProperty(this, "openSearch", () => {
      const {
        isActive
      } = this.state;
      if (!isActive) {
        this.setState({
          isActive: true
        }, () => disableBodyScroll(this.target));
        if (this.props.isLoggedIn) {
          getViewedProducts().then(views => this.setState({
            views
          }));
          getSubscriptions().then(subscriptions => this.setState({
            subscriptions
          }));
        }
      }
    });
    _defineProperty(this, "closeSearch", () => {
      clearAllBodyScrollLocks();
      if (this.input) {
        this.input.value = '';
        this.input.blur();
      }
      this.setState({
        isActive: false,
        textWidth: 0,
        searching: false,
        results: [],
        showResults: false,
        selected: -1,
        type: null
      });
    });
    _defineProperty(this, "handleShortcutLinkClick", () => {
      this.closeSearch();
    });
    _defineProperty(this, "setSelected", selectedIndex => {
      this.setState({
        selected: selectedIndex
      });
    });
    _defineProperty(this, "debouncedSearchTerm", debounce(trackSearchTerm, 500));
    _defineProperty(this, "handleChange", () => {
      if (!this.input) return;
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.setState({
        searching: true
      });
      this.searchTimeout = setTimeout(() => {
        const searchTerm = this.input.value.trim();
        if (searchTerm && searchTerm.length > 2) {
          this.getResults(searchTerm);
          this.debouncedSearchTerm(searchTerm);
        } else {
          this.hideResults();
        }
        if (!this.spanText) return;
        this.spanText.innerText = searchTerm;
        this.setState({
          textWidth: this.spanText.offsetWidth
        });
      }, 500);
    });
    _defineProperty(this, "handleKeyDown", event => {
      const {
        selected,
        results
      } = this.state;
      switch (event.keyCode) {
        case keyMap.ENTER:
        case keyMap.RETURN:
          if (selected === -1) {
            event.preventDefault();
          } else {
            const {
              entity,
              type,
              url
            } = results[selected];
            const cleanSubtype = entity && entity.hasOwnProperty('subtype') ? entity.subtype : type;
            const productType = getProductTypeById(cleanSubtype);
            const linkUrl = productType && ['content'].includes(productType.category) ? "/".concat(productType.slug, "/").concat(url) : url;
            location.href = linkUrl;
            this.closeSearch();
          }
          break;
        case keyMap.UP:
          event.preventDefault();
          return this.setState(state => ({
            selected: state.selected > 0 ? state.selected - 1 : state.results.length - 1
          }));
        case keyMap.DOWN:
          event.preventDefault();
          return this.setState(state => ({
            selected: state.selected < state.results.length - 1 ? state.selected + 1 : 0
          }));
        case keyMap.ESCAPE:
          event.preventDefault();
          return this.closeSearch();
        default:
          break;
      }
    });
  }
  componentWillUnmount() {
    this.pendingPromises.map(promise => promise.cancel());
  }
  render() {
    const {
      finectApp
    } = this.props;
    const {
      isActive,
      textWidth,
      showResults,
      results,
      selected
    } = this.state;
    const docs = results.reduce((map, doc) => _objectSpread(_objectSpread({}, map), {}, {
      [doc.type]: (map[doc.type] || 0) + 1
    }), {});
    return React.createElement(SearchBar, null, React.createElement(SearchBarContent, {
      onClick: this.openSearch,
      isActive: isActive
    }, React.createElement(SearchBarInner, {
      isActive: isActive
    }, React.createElement(SearchIcon, {
      isActive: isActive
    }, React.createElement(Search, {
      size: "18",
      strokeWidth: "2.2"
    })), React.createElement(SearchInput, {
      ref: el => this.input = el,
      placeholder: "Busca fondos de inversi\xF3n, planes de pensiones, ETFs...",
      isActive: isActive,
      onKeyDown: this.handleKeyDown,
      onChange: this.handleChange
    }), React.createElement(SearchText, {
      ref: el => this.spanText = el
    }), React.createElement(TextProgress, {
      isActive: isActive,
      textWidth: textWidth
    }), isActive && React.createElement(Fragment, null, React.createElement(SearchType, {
      isActive: isActive
    }, React.createElement(Tag, {
      small: true
    }, this.state.type)), React.createElement(CloseSearch, {
      onClick: this.closeSearch
    }, React.createElement(X, {
      size: "20",
      strokeWidth: "2.2"
    }))))), isActive ? React.createElement(OmniSearchBlock, {
      ref: el => this.target = el,
      loading: this.state.searching
    }, React.createElement(SearchResults, null, React.createElement(SearchResultsInner, null, React.createElement("div", {
      style: {
        marginBottom: '10px'
      }
    }, Object.keys(docs).map(key => React.createElement(Tag, {
      key: key,
      small: true,
      color: "accent1",
      withMargin: true,
      onClick: () => this.selectTag(key)
    }, key, React.createElement("span", {
      style: {
        margin: '0 10px',
        padding: '2px 4px',
        backgroundColor: '#80b3ff',
        border: '1px solid #fff',
        fontSize: '10px',
        color: '#fff'
      }
    }, docs[key])))), showResults ? React.createElement("div", null, results.filter(item => !this.state.type || this.state.type === item.type).slice(0, 15).map((result, index) => React.createElement(SearchResultItem, {
      key: result.id,
      finectApp: finectApp,
      result: result,
      index: index,
      isSelected: selected === index,
      following: this.isFollowing(result.type, result.id),
      hideResults: this.closeSearch,
      setSelected: this.setSelected,
      subscribe: this.handleSubscribe,
      unsubscribe: this.handleUnSubscribe
    }))) : React.createElement(Fragment, null, React.createElement(SearchShortcuts, {
      finectApp: this.props.finectApp || null,
      onLinkClick: this.handleShortcutLinkClick
    }))))) : null);
  }
}